var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-group-video-film-header" }, [
    _c("div", { staticClass: "title-wrap" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.getRoomGroupName(_vm.roomGroup.roomGroupId))),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "btn-wrap" },
      [
        _vm.hasEmceeRole()
          ? [
              _c("button", {
                staticClass: "room-group-control-button mic",
                attrs: { "data-device-status": _vm.micStatus },
                on: { click: _vm.onChangeRoomGroupMicMuteState },
              }),
              _c("button", {
                staticClass: "room-group-control-button speaker",
                attrs: { "data-device-status": _vm.speakerStatus },
                on: { click: _vm.onChangeRoomGroupSpeakerMuteState },
              }),
              _c("button", {
                staticClass: "room-group-control-button layout",
                on: {
                  click: () =>
                    (this.showRoomGroupLayout = !this.showRoomGroupLayout),
                },
              }),
            ]
          : _vm._e(),
        _c("button", {
          staticClass: "room-group-control-button hide-header",
          on: { click: () => this.$emit("close") },
        }),
      ],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showRoomGroupLayout,
            expression: "showRoomGroupLayout",
          },
        ],
        staticClass: "room-group-layout",
      },
      [
        _c(
          "ul",
          { staticClass: "room-group-layout-list" },
          _vm._l(_vm.layoutList, function (layout) {
            return _c(
              "li",
              {
                key: layout,
                staticClass: "room-group-layout-item",
                on: {
                  click: function ($event) {
                    return _vm.onChangeRoomGroupLayoutType(layout)
                  },
                },
              },
              [
                _c("button", {
                  staticClass: "room-group-layout-button",
                  class: {
                    selected:
                      layout === (_vm.videoLayout || _vm.roomGroupLayout),
                  },
                  style: _vm.layoutStyle(layout),
                  attrs: { "data-layout": layout },
                }),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }